import AccountInventoryService from '@/services/accountinventory.service.js'
import OppregAdminService from '@/services/oppregadmin.service.js'
import ChangeLogService from '@/services/changelog.service.js'
import FinancialAdminService from '@/services/financeadmin.service'
import awsAcctService from '@/services/awsacct.service.js'

import { initRefreshData } from '@/utils/helper'
// import { async } from 'q'

export default {
  init: async context => {
    // context.commit('setLoader', { text: 'Setting up account inventory', loading: true }, { root: true })
    // let accounts = await AccountInventoryService.initAccountData()
    // context.commit('accountInventory/setInitData', accounts)
    // context.commit('setInitMPayer', accounts.masterPayers)

    // context.commit('setLoader', { text: 'Setting up oppreg administration' }, { root: true })
    // let workloads = await OppregAdminService.initOppregData()
    
    // context.commit('oppregAdmin/setInitData', workloads.oppreg_data)
    // context.commit('setCustomerList', workloads.customer_region)

    context.commit('setLastSyncDateTime', window.moment().format('M/D/Y H:mm:ss'), { root: true })

    context.commit('setLoader', { loading: false }, { root: true })
    context.commit('setInitialLoad', true, { root: true })
    console.log('admin init')
    AccountInventoryService.getAllMasterpayers(null, (res, err) => {
      console.log('res', res)
      context.commit('setInitMPayer', res.masterpayers)
      context.commit('accountInventory/setMasterpayers', res.masterpayers)
      // context.commit('setNextData', res.next_data)
      // context.commit('setLoadingAccountData', false)
    })

    // start polling
    // initRefreshData()
  },

  loadMasterpayers: async (context) => {
    console.log('loading payers')
    AccountInventoryService.getAllMasterpayers(null, (res, err) => {
      console.log('res', res)
      context.commit('setInitMPayer', res)
      // context.commit('setNextData', res.next_data)
      // context.commit('setLoadingAccountData', false)
    })
  },
  saveNewCustomer: async (context, fields) => {
    context.commit('setNewCustomerSaving', true)
    OppregAdminService.saveNewCustomer(fields, (res, err) => {  
      if (err) {
        context.commit('setSavingResponse', { showResponse: true, responseType: 'error', responseMessage: err.message })
      } else {
        context.commit('setSavingResponse', { showResponse: true, responseType: 'success', responseMessage: res.message })
        context.commit('addRecordToCustomerList', { Customer_Id: res.id, ...fields })
      }
      context.commit('setNewCustomerSaving', false)
    })
  },

  saveNewCustomerAndAssign: async (context, fields) => {
    context.commit('setNewCustomerSaving', true)
    OppregAdminService.saveNewCustomer(fields, (res, err) => {
      if (err) {
        context.commit('setSavingResponse', { showResponse: true, responseType: 'error', responseMessage: err.message })
      } else {
        context.commit('setSavingResponse', { showResponse: true, responseType: 'success', responseMessage: res.message })
        context.commit('addRecordToCustomerList', { ...fields, Customer_Id: res.id })
        context.commit('assignNewCustomerToAccount', { ...fields, Customer_Id: res.id })
      }
      context.commit('setNewCustomerSaving', false)
    })
  },
  
  updateCustomer: async (context, fields) => {
    context.commit('setNewCustomerSaving', true)
    OppregAdminService.updateCustomer(fields, (res, err) => {
      if (err) {
        context.commit('setSavingResponse', { showResponse: true, responseType: 'error', responseMessage: err.message })
      } else {
        context.commit('setChangeLogRecord', { id: fields.Customer_Id, changeTo: fields, module: 'customer' }, { root: true })
        context.commit('setSavingResponse', { showResponse: true, responseType: 'success', responseMessage: res.message })
        context.commit('updateCustomerList', fields)
        context.commit('updateCustomer', fields.Customer_Id)
        ChangeLogService.create(context.rootState.logRecord)
      }
      context.commit('setNewCustomerSaving', false)
    })
  },

  deleteCustomer: async (context, id) => {
    OppregAdminService.deleteCustomer(id, (customers, err) => {
      if (err) {
        // context.commit('setCustomerList', customers)
      } else {
        context.commit('deleteRecordOnCustomerList', id)
        context.commit('showDialog', { show: false }, { root: true })
      }
    })
  },

  saveNewAccount: (context, account) => {
    context.commit('savingAccount', true)
    context.commit('setChangeLogRecord', { id: account.Acct_ID, changeTo: account, module: 'account-inventory' }, { root: true })
    AccountInventoryService.saveNewAccount(account, (res, err) => {
      if (err) {
        context.commit('setAccountDialogResponse', { saved: true, alertType: 'error', alertMessage: 'An error has occured' })
      } else {
        context.commit('setAccountDialogResponse', { saved: true, alertType: 'success', alertMessage: 'Successfully created new Account' })
        if (context.rootState['admin/accountInventory'].masterPayers) {
          // lets add agreement type
          let masterPayer = context.rootState['admin/accountInventory'].masterPayers.find(mp => {
            return mp.Master_Id === account.Master_Id
          })
          if (masterPayer !== undefined && masterPayer.Agreement !== undefined) {
            let agreementType = masterPayer.Agreement.toLowerCase()
            account['agreement'] = agreementType
            account['MP_ID'] = masterPayer.MP_ID
          }
          context.commit('accountInventory/addToAccountList', account)
          ChangeLogService.create(context.rootState.logRecord)
        }
      }
    })
  },

  updateAccount: (context) => {
    context.commit('savingAccount', true)
    
    context.state.accountDialog.fields.Validation_Type = 'Manual'
    context.state.accountDialog.fields.Last_Date_Validated = new Date().toISOString().substr(0, 10)

    context.commit('setChangeLogRecord', { id: context.state.accountDialog.fields.Acct_ID, changeTo: context.state.accountDialog.fields, module: 'account-inventory' }, { root: true })
    
    AccountInventoryService.updateAccount(context.state.accountDialog.fields, (res, err) => {
      if (err) {
        context.commit('setAccountDialogResponse', { saved: true, alertType: 'error', alertMessage: 'An error has occured' })
      } else {
        context.commit('setAccountDialogResponse', { saved: true, alertType: 'success', alertMessage: 'Successfully updated Account' })
        context.commit('accountInventory/updateAccountList', context.state.accountDialog.fields)
        ChangeLogService.create(context.rootState.logRecord)
      }
    })
  },


  updateAccountAWSAPNData: (context, fields) => {
    context.commit('savingAccount', true)
    context.commit('setChangeLogRecord', { id: context.state.accountDialog.fields.Acct_ID, changeTo: context.state.accountDialog.fields, module: 'account-inventory' }, { root: true })
    AccountInventoryService.updateAccountAWSAPNData(fields, (res, err) => {
      if (err) {
        context.commit('setAccountDialogResponse', { saved: true, alertType: 'error', alertMessage: 'An error has occured' })
      } else {
        context.commit('setAccountDialogResponse', { saved: true, alertType: 'success', alertMessage: 'Successfully updated AWS/APN Data' })
        context.commit('accountInventory/updateAccountList', context.state.accountDialog.fields)
        ChangeLogService.create(context.rootState.logRecord)
      }
      context.commit('savingAccount', false)
    })

  },

  searchCustomers: (context, data) => {
    context.commit('setCustomerSearchLoading', true)
    AccountInventoryService.searchCustomers(data, (res, err) => {
      if (err) {

      } else {
        context.commit('setCustomerSearchList', res)
        context.commit('setCustomerSearchLoading', false)
      }
    })
  },

  validateOppregId (context, id) {
    context.commit('setOppIdExistsLoading', true)
    AccountInventoryService.validateOppRegId(id, res => {
      if(res.length > 0){
        context.commit('setOppIdExistsLoading',false)
        context.commit('setOppRegIdAvailabilityMessage', {type: 'success', isWorkload: true, message: 'Opportunity Registration ID exist.'})
        context.commit('setOppregWorkloads', res )
        
        context.commit('setProjectId', res[0].Project_Id)
        
        
      } else {
        context.commit('setOppIdExistsLoading',false)
        context.commit('setOppRegIdAvailabilityMessage', {type: 'error',isWorkload: false,  message: 'Opportunity Registration ID Does not exist. This value will not be saved'})
      }
    })
  },

  checkIfAccountIdIsAvailable: (context, id) => {
    if (id.length > 12) {
      context.commit('setAccountIdAvailabilityMessage', { type: 'error', message: 'Account Id should only contain 12 digits' })
    } else {
      context.commit('setAccountIdExistLoading', true)
      AccountInventoryService.checkIfAccountIdIsAvailable(id, (res, err) => {
        if (err && err.acctExist) {
          context.commit('setAccountIdAvailabilityMessage', { type: 'error', message: 'This Acct ID has already been registered.' })
        } else {
          context.commit('setAccountIdAvailabilityMessage', { type: 'success', message: 'This Acct ID is available to use.' })
        }
        context.commit('setAccountIdExistLoading', false)
      })
    }
  },

  checkIfOpportunityNumberIsAvailable: (context, id) => {
    
    context.commit('setAceOppNumExistLoading', true)
    AccountInventoryService.checkIfOpportunityNumberIsAvailable(id, (res, err) => {
      if (err && err.opportunityNumberExist) {
        context.commit('setAceOppNumAvailabilityMessage', { type: 'error', message: 'This ACE Opportunity Number has already been used.' })
      } else {
        context.commit('setAceOppNumAvailabilityMessage', { type: 'success', message: 'This ACE Opportunity Number is available to use.' })
      }
      context.commit('setAceOppNumExistLoading', false)
    })
  },

  saveNewMasterPayer: (context, data) => {
    context.commit('setNewMasterPayerSaving', true)
    AccountInventoryService.saveNewMasterPayer(data, (res, err) => {
      if (err) {
        context.commit('setMpSavingResponse', { showResponse: true, responseType: 'error', responseMessage: err.message })
      } else {
        context.commit('setMpSavingResponse', { showResponse: true, responseType: 'success', responseMessage: res.data.response })
        context.commit('setNewMasterPayerSaving', false)
      }
      context.commit('setNewMasterPayerSaving', false)
    })
  },

  updateMPayer: (context, data) => {
    context.commit('setNewMasterPayerSaving', true)
    AccountInventoryService.updateMPayers(data, (res, err) => {
      if (err) {
        context.commit('setMpSavingResponse', { showResponse: true, responseType: 'error', responseMessage: err.message })
      } else {
        context.commit('setChangeLogRecord', { id: data.Master_Id, changeTo: data, module: 'master-payer' }, { root: true })
        context.commit('setMpSavingResponse', { showResponse: true, responseType: 'success', responseMessage: res.response })
        context.commit('updateMasterPayerList', data)
        context.commit('setNewMasterPayerSaving', false)
        ChangeLogService.create(context.rootState.logRecord)
      }
      context.commit('setNewMasterPayerSaving', false)
    })
  },

  deleteMasterPayer: (context, id) => {
    context.commit('showDialog', { yesHandlerLoading: true }, { root: true })
    AccountInventoryService.deleteMasterPayer(id, (res, err) => {
      if (err) {
        // context.commit('setMpSavingResponse', { showResponse: true, responseType: 'error', responseMessage: err.message })
      } else {
        context.commit('resetDialog', null, { root: true })
        context.commit('deleteMasterPayer', id)
      }
    })
  },

  checkLinkAccounts: (context, id) => {
    let linkedAccounts = context.rootState['admin/accountInventory'].masterAccounts.filter(account => account.Master_Id == id)
    if (linkedAccounts.length) {
      context.commit('showLinkedAccounts', {
        id: id,
        mpid: linkedAccounts[0].MP_ID,
        accounts: linkedAccounts
      })
    } else {
      context.commit('showDialog', {
        show: true,
        yesHandler: () => {
          context.dispatch('deleteMasterPayer', id)
        },
        noHandler: () => {
          context.commit('showDialog', {
            show: false
          }, { root: true })
        },
        type: 'confirmation',
        persistent: true,
        title: `Do you want to delete this MasterPayer: ${id}?`,
        yesLabel: 'Yes',
        noLabel: 'No'
      }, { root: true })
    }
  },

  validateMasterPayerMPId: (context, mpId) => {
    AccountInventoryService.validateMasterPayerMPId(mpId, (res, err) => {
      if (err && err.duplicateTitle) {
        context.commit('setMpIdValidation', {
          error: true,
          success: false,
          errorMessage: 'MP ID that you have entered already exist'
        })
      } else {
        context.commit('setMpIdValidation', {
          error: false,
          success: true,
          successMessage: 'MP ID is available to use'
        })
      }
    })
  },

  // Financial Administration
  findSfdcId: (context, data) =>{
    console.log('----- action: findsfdcId -----')
    console.log(data)
    console.log('------------------------------')
    context.commit('setSFDCValidating', true)
    FinancialAdminService.findSfdcId(data.sfdcId, (res, err) => {
      if(err){

      } else{
        // condition: if SFDC Opp Status NOT EQUAL to the External SFDC Opp status
        let acctOppStatus = data.sfdcOppStatus
        // let acctOppStatus = 'win'
        if(acctOppStatus !== res){
          console.log('condition: trueeeee')
          context.commit('setSFDCOppStatus', res)
          let updateObj = {
            Id: data.Id,
            SFDC_Opp_Status: res
          }
          context.commit('setChangeLogRecord', { changeTo: updateObj }, {root: true})
          FinancialAdminService.updateFinanceAccount(updateObj, (res,err) => {
            if(err){

            } else{
              console.log('-----UPDATE SFDC OPP STATUS : RESULT------')
              console.log(res)
              console.log('-----------------------------------------')
              ChangeLogService.create(context.rootState.logRecord )
              context.commit('setSFDCValidationResponse', { validated: true, msg: 'SFDC has been validated'})
              context.commit('financialAdministration/updateFinanceList', context.state.financeDialog.fields)
            }
          })
        } else {
          console.log('No changes! Validated')
          // setSfdcStatus 
          context.commit('setSFDCValidationResponse', {validated: true, msg: 'Validated. No changes required'})
          context.commit('financialAdministration/updateFinanceList', context.state.financeDialog.fields)
        }
      }
    })
  },

  updateFinanceAccount: (context) => {
    context.commit('savingFinanceAccount', true)
    context.commit('setChangeLogRecord', { changeTo: context.state.financeDialog.fields }, { root: true })
    FinancialAdminService.updateFinanceAccount(context.state.financeDialog.fields, (res, err) => {
      if (err) {
        context.commit('setFinanceSavingResponse', { saved: true, alertType: 'error', alertMessage: 'An error has occured' })
      } else {
        context.commit('setFinanceSavingResponse', { showResponse: true, responseType: 'success', responseMessage: res.message })
        context.commit('savingFinanceAccount', false)
        context.commit('financialAdministration/updateFinanceList', context.state.financeDialog.fields)
        ChangeLogService.create(context.rootState.logRecord)
      }
    })
  },

  retrieveEmailTrail: (context, params) => {
    context.commit('setLoadingRequest', true)
    OppregAdminService.retrieveEmailAuditTrail(params, (res, err) => {
      if (err) {
        if (err) {
          context.commit('setSnackbar',
            {
              show: true,
              type: 'error',
              timeout: 20000,
              message: err.message
            },
            { root: true }
          )
          // context.commit('setNotification', { withError: true })
          context.commit('setEmailAuditList', [])
        }
      } else {
        if (res.EmailAuditData && res.EmailAuditData.length > 0) {
          context.commit('setEmailAuditList', res.EmailAuditData)
        } else {
          context.commit('setEmailAuditList', [])
          // context.commit('setNotification', { withError: true })
        }
        
      }
      context.commit('setLoadingRequest', false)
    })

  },

  downloadMasterpayerActiveReport: (context, params) => {
    AccountInventoryService.downloadMasterpayerActiveReport( params, (res, err) => {
      if (err) {

      } else {
        // redirect to a new tab
        console.log(res)
      }
    })
  },

  downloadMasterpayerChildReport: (context, params) => {
    AccountInventoryService.downloadMasterpayerChildReport( params, (res, err) => {
      if (err) {

      } else {
        // redirect to a new tab
        context.commit('setLinkedAccountsReportGenerated', true)
      }
    })
  },
  getAllCustomers: (context) => {
    console.log('getting all customers')
    awsAcctService.getAllCustomers(res => {
      console.log('res', res)
      context.commit('setListOfCustomers', res)
    })
  },
}
